import { gql } from "@apollo/client";
import { addDays, format } from "date-fns";

import { NUMBER_OF_SUBTRACTED_DAYS } from "../../utils/complaintsConstants";
import { GRAPHQL_METHODS } from "../../utils/constants";
import { dateToISO } from "../../utils/dates";
import { networkGraphqlRequest } from "../../utils/networkUtils";

const GET_COMPLAINTS = gql`
  query GetAllDemands($query: PaginationQuery!) {
    getAllDemand(query: $query) {
      page
      limit
      totalCount
      totalPages
      docs {
        demandIdentityByUser
        demandType
        registerDate
        caseNumber
        business
        status {
          label
          category
        }
        area
        reason
      }
    }
  }
`;

function requestData(client, page, searchParams, networkOnly) {
  const params = {
    query: {
      page: page,
      ...searchParams,
      date: searchParams.date
        ? dateToISO(searchParams.date)
        : format(addDays(new Date(), -NUMBER_OF_SUBTRACTED_DAYS), "yyyy-MM-dd"),
    },
  };
  return networkGraphqlRequest(
    GRAPHQL_METHODS.QUERY,
    client,
    GET_COMPLAINTS,
    params,
    networkOnly
  );
}

export default requestData;
